import { render } from "./CandidateExperienceTab.vue?vue&type=template&id=319f74fd"
import script from "./CandidateExperienceTab.vue?vue&type=script&lang=js"
export * from "./CandidateExperienceTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__